export const TASK_TIMEOUT = 30000
// 45 minutes of polls, longer than the longest backend task timeout (30 minutes for repository export and clone).
export const TASK_OBSERVATION_MAX_POLLS = (45 * 60 * 1000) / TASK_TIMEOUT
